import { useQuery } from '@tanstack/react-query';

import { listCompanies, listPermissions } from '../../api/business/endpoints';
import { usePermissions } from '../../auth/usePermissions';
import { hasGrant } from '../../components/grantMatrix';

/** What the permission matrix needs: the catalogue, the active companies, and what the editor may hand out. */
export const useGrantContext = () => {
  const permissions = usePermissions();
  const definitions = useQuery({
    queryKey: ['permissions'],
    queryFn: listPermissions,
    staleTime: 5 * 60_000,
  });
  const companies = useQuery({ queryKey: ['companies'], queryFn: listCompanies });

  return {
    definitions: definitions.data ?? [],
    companies: (companies.data ?? []).filter((company) => company.status === 'ACTIVE'),
    isLoading: definitions.isLoading || companies.isLoading,
    error: definitions.error ?? companies.error,
    canGrant: (permission: string, companyId: string | null): boolean =>
      permissions.isOwner || hasGrant(permissions.grants, permission, companyId),
  };
};
